import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCallStart } from "./callStart.service";
import { CallStartData } from "./callStart.types";
import { RejectValueType } from "../redux/redux.types";
import { RootState } from "../../store";
import { handleApiError } from "@/app/utils/handleApiError";

export const getCallStart = createAsyncThunk<
  CallStartData,
  void,
  RejectValueType & { state: RootState }
>(
  "callStart/getCallStart",
  async (_, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState();
      const profile = auth.userProfile;
      const response = await fetchCallStart(
        profile
          ? {
              firstname: profile.firstname,
              lastname: profile.lastname,
              phone_number: profile.phone,
            }
          : undefined,
      );
      return response;
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  },
  {
    condition: (_, { getState }) => {
      const { callStart } = getState();
      if (callStart.status === "loading") return false;
      return true;
    },
  },
);